<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-row justify="center">
      <v-form ref="queryForm" style="width:90%;">
        <v-row justify="center">
          <v-col cols="2" xs="4">
            <v-text-field
                clearable
                v-model="queryRequest.acctName"
                label="姓名"
                single-line/>
          </v-col>

          <v-col cols="2" xs="4">
            <v-text-field
                clearable
                v-model="queryRequest.cellPhone"
                label="手机号"
                single-line/>
          </v-col>
          <v-col cols="2" xs="4">
            <z-source-selector label="请选择角色" v-model="queryRequest.roleType"
                               source="RoleSelector"/>
          </v-col>
          <v-col cols="2" xs="4">
            <z-source-selector  clearable v-model="queryRequest.wmsIds"
                               prepend-inner-icon="search"
                               label="仓库"
                               single-line
                               hide-details="auto"
                               source="WarehouseSelector"/>
          </v-col>

          <v-col cols="3" xs="4">
            <v-btn color="primary" :loading="loading" @click="query">
              搜索
              <v-icon right>mdi-magnify</v-icon>
            </v-btn>
            <v-btn color="primary" class="ma-2" @click="resetQuery">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-row>

    <v-row class="d-flex justify-center">
      <v-col :sm="11" :xs="12" cols="8">
        <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :page.sync="queryRequest.pagedQueryInfo.index"
            :server-items-length="total"
            :loading="loading"
            :search="search"
            :footer-props="footerOptions">
          <template v-slot:top>
            <v-toolbar height="40" flat>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn small color="primary" v-on="on">添加
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">医院同步模式添加</span>
                  </v-card-title>

                  <v-card-text v-if="hospAddStep==0">
                    <v-container>
                      <v-form ref="hospUserAddFormOne"
                              v-model="hospUserAddFormOneValid"
                      >
                        <v-row align="center">
                          <v-col cols="6">
                            <v-text-field v-model="hospUserRequest.acctNo"
                                          :rules="[v => !!v || '手机号为必选项']"
                                          label="请输入手机号">
                            </v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-btn :disabled="!hospUserRequest.acctNo"
                                   :loading="hospUserRequestLoading" @click="hospUserQuery">
                              查询医院用户
                              <v-icon right>mdi-magnify</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-text v-if="hospAddStep==1">
                    <v-container>
                      <v-form ref="hospUserAddForm" v-model="hospUserAddFormValid">
                        <v-col cols="12">
                          <v-text-field v-model="newItem.acctName"
                                        :rules="[v => !!v || '角色为必选项']"
                                        disabled
                                        label="姓名"/>
                        </v-col>
                        <v-col cols="12">
                          <z-source-selector label="请选择角色"
                                             v-model="newItem.roleType"
                                             :rules="[v => !!v || '角色为必选项']"
                                             source="RoleSelector"/>
                        </v-col>
                        <v-col cols="12">
                          <z-source-selector v-show="newItem.roleType === '03'"
                                             clearable v-model="newItem.wmsIdList"
                                             prepend-inner-icon="search"
                                             label="仓库"
                                             multiple
                                             single-line
                                             hide-details="auto"
                                             source="WarehouseSelector"/>
                        </v-col>
                      </v-form>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--<v-btn color="blue darken-1" text @click="hospAddStep=0">关闭</v-btn>-->
                        <v-btn color="darken-1"
                               text
                               v-if="hospAddStep==1"
                               @click="hospAddStep=0">上一步
                        </v-btn>
                        <v-btn color="blue darken-1"
                               :loading="newItemCommitLoading"
                               :disabled="!hospUserAddFormValid"
                               text
                               v-if="hospAddStep==1"
                               @click="addCommit">提交
                        </v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn class="mr-3" small color="primary" @click="handleAcctInfoChange(item)">修改
            </v-btn>
            <v-btn small color="error" @click="handleDelete(item)">离职
            </v-btn>
          </template>


        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="changeAcctInfoDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">信息变更</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <z-source-selector label="角色" v-model="changeAcctInfoReq.roleType"
                               source="RoleSelector"/>
            <z-source-selector v-show="changeAcctInfoReq.roleType === '03'"
                               clearable v-model="changeAcctInfoReq.wmsIdList"
                               prepend-inner-icon="search"
                               label="仓库"
                               multiple
                               single-line
                               hide-details="auto"
                               source="WarehouseSelector"/>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="changeAcctInfoDialog = false">关闭</v-btn>
          <v-btn color="blue darken-1"
                 text
                 @click="acctInfoChange()">提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="deleteDialog"
        width="500"
    >
      <v-card>
        <v-card-title>
          <span>请确认是否离职:{{ deleteItem.acctName }}</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">取消</v-btn>
          <v-btn
              color="error"
              text
              @click="deleteCommit"
          >
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
        top
        v-model="snackbar"
    >
      {{ snackbarText }}

    </v-snackbar>

    <z-notify ref="notify"></z-notify>

  </div>
</template>

<script>
import {
  queryRequest,
  hospModelAcctAdd,
  deleteAcct,
  hospUserInfoQuery,
  changeRole,
  updateAcctInfo
} from '@/api/usermanagement'

export default {
  name: "UserManagement",
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 50, 100, 200]
      },
      snackbar: false,
      snackbarText: '',
      hospAddStep: 0,  //0 查询手机用户 ,1 回显用户，选择公司后提交
      dialog: false,
      changeAcctInfoDialog: false,
      updateDialog: false,
      search: '',
      total: 0,
      list: [],
      loading: false,
      options: {},
      headers: [
        {text: '姓名', value: 'acctName', sortable: false, align: 'center',},
        {text: '手机号', value: 'cellPhone', sortable: false, align: 'center',},
        {text: '角色', value: 'roleTypeDesc', sortable: false, align: 'center',},
        {text: '状态', value: 'stateDesc', sortable: false, align: 'center',},
        {text: '仓库', value: 'wmsIdsDesc', sortable: false, width: 200, align: 'center',},
        {text: '公司', value: 'companyName', sortable: false, align: 'center',},
        {text: '操作', value: 'actions', sortable: false, align: 'center',},
      ],
      hospUserRequest: {
        acctNo: ''
      },
      hospUserRequestLoading: false,
      queryRequest: {
        id: "",
        acctId: "",
        acctName: "",
        cellPhone: "",
        roleType: "",
        state: "",
        wmsIds: "",
        companyId: "",
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        }
      },
      changeAcctInfoReq: {
        id: '',
        roleType: '',
        wmsIdList: [],
      },
      newItem: {
        acctId: "string",
        acctName: "string",
        cellPhone: "string",
        companyId: "string",
        roleType: "string"
      },
      step: 0,
      hospUserAddFormValid: false,
      hospUserAddFormOneValid: false,
      newItemCommitLoading: false,
      hospUerInfo: {
        cellPhone: '',
        acctName: '',
        remark: '',
        compName: '',
        id: '',
        hospNameList: []
      },
      editedItem: {},
      deleteDialog: false,
      deleteItem: {
        acctName: ''
      }
    }
  },
  watch: {
    options: {
      handler(val) {
        console.log(val)
        if (val.itemsPerPage == -1) {
          this.queryRequest.pagedQueryInfo.index = 1
          this.queryRequest.pagedQueryInfo.pageSize = 999999
        } else {
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        // this.queryRequest.sortInfo.sortBy = val.sortBy
        // this.queryRequest.sortInfo.sortDesc = val.sortDesc
        this.handleQuery()
      }
    }
  },
  methods: {
    query() {
      this.queryRequest.pagedQueryInfo.index = 1;
      this.handleQuery();
    },
    resetQuery() {
      this.$refs.queryForm.reset();
      this.query();
    },
    handleQuery() {
      this.loading = true
      queryRequest(this.queryRequest).then(res => {
        this.list = res.list
        this.total = res.total
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },

    handleDelete(item) {
      this.deleteItem = item
      this.deleteDialog = true
    },
    hospUserQuery() {
      this.hospUserRequestLoading = true
      hospUserInfoQuery(this.hospUserRequest).then(res => {
        if (res.noUser) {
          this.snackbarText = "无此用户"
          this.snackbar = true
        } else {
          this.hospUerInfo = res
          this.newItem = res
          this.newItem.acctId = this.hospUerInfo.id
          this.hospAddStep = 1
        }
        this.hospUserRequestLoading = false
      }).catch(err => {
        this.hospUserRequestLoading = false
      })
    },
    handleAcctInfoChange(item) {
      this.changeAcctInfoReq = JSON.parse(JSON.stringify(item))
      this.changeAcctInfoDialog = true
    },
    acctInfoChange() {
      let _this = this;
      updateAcctInfo(_this.changeAcctInfoReq).then(res => {
        _this.changeAcctInfoDialog = false;
        _this.handleQuery();
        _this.$refs.notify.show("信息修改成功", {timeout: 1000, color: 'success'});
      }).catch(err => {

      })
    },
    addNextStep() {

      // 调接口获取manager系统用户信息

      this.step++;

    },
    addCommit() {
      if (this.hospUserAddFormValid) {
        this.newItemCommitLoading = true;
        hospModelAcctAdd(this.newItem).then(res => {
          this.newItemCommitLoading = false;
          this.dialog = false;
          this.hospAddStep = 0;
          this.$refs.notify.show("用户添加成功", {timeout: 1000, color: 'success'});
          this.handleQuery();
          this.step = 0;
          Object.assign(this.newItem, this.$options.data().newItem);
          Object.assign(this.hospUerInfo, this.$options.data().hospUerInfo);
        }).catch(err => {
          this.newItemCommitLoading = false
        })
      }
    },
    deleteCommit() {
      deleteAcct(this.deleteItem.id).then(res => {
        this.deleteDialog = false
        this.snackbarText = "操作成功"
        this.snackbar = true
        this.handleQuery()
      }).catch(err => console.error(err))
    }
  }
}
</script>

<style scoped>

</style>
